export const projectsData = [
  {
    id: "mealPlan",
    title: "Uber - Meal Plan",
    images: [
      "/portfolio/mealplan_1.png",
      "/portfolio/mealplan_2.png",
      "/portfolio/mealplan_3.png",
    ],
    description:
      "Engineered the front-end components and API integrations that power Uber's automated corporate meals tool, allowing organizations to seamlessly manage budgets, schedules, and menus while empowering employees to select their own meals.",
    tools: ["TypeScript", "React", "RPC"],
    timeline: "September 2025 - Present",
    buttons: [
      {
        label: "Try on Uber",
        link: "https://www.uber.com/us/en/blog/meal-planning/",
      },
    ],
  },
  {
    id: "savedGroups",
    title: "Uber - Saved Groups",
    images: ["/portfolio/savedGroups.png"],
    description:
      "New feature that allows users to create personal or business groups, and subsequently book group rides / orders, or share payment with other members.",
    tools: ["TypeScript", "React", "Figma"],
    timeline: "January 2025 - June 2025",
    buttons: [
      { label: "Try on Uber", link: "https://mbiz.uber.com/groups/ftux" },
    ],
  },
  {
    id: "foodmarks",
    title: "Foodmarks",
    images: ["/portfolio/foodmarks.png"],
    description:
      "Mobile app designed to help users discover new restaurants, plan social events, vote on dining options, and accommodate dietary restrictions within a group.",
    tools: ["React", "Expo", "JavaScript", "Firebase"],
    timeline: "Spring 2024",
    buttons: [
      {
        label: "Article",
        link: "https://drive.google.com/file/d/1ZODz2OI5Rj062FakYQVAgmRchiBbyFAp/view?usp=drive_link",
      },
    ],
  },
  {
    id: "trumpetExplorable",
    title: "How Does the Trumpet Work? - Educational Explorable",
    images: [
      "/portfolio/trumpet_1.png",
      "/portfolio/trumpet_2.png",
      "/portfolio/trumpet_3.png",
    ],
    description:
      "Educational explorable that explains the history and physics behind the trumpet, as well as allows the user to play with a trumpet simulator.",
    tools: ["VegaLite", "D3", "JavaScript", "Observable"],
    timeline: "Winter 2024",
    buttons: [
      {
        label: "Explore here",
        link: "https://observablehq.com/d/bb22d784399a3b05",
      },
    ],
  },
  {
    id: "coffee",
    title: "Exploring Coffee Production, Consumption, and Characteristics",
    images: [
      "/portfolio/coffee_1.png",
      "/portfolio/coffee_2.png",
      "/portfolio/coffee_3.png",
    ],
    description:
      "Data visualization tool that captures the history of coffee, as well as consumption, flavor palettes, and other notable data.",
    tools: ["VegaLite", "D3", "JavaScript", "Observable"],
    timeline: "Fall 2023",
    buttons: [
      {
        label: "Explore here",
        link: "https://observablehq.com/d/53f9a60b9807b0f4",
      },
    ],
  },
  {
    id: "crosswordGenerator",
    title: "Automatic Crossword Generator",
    images: [
      "/portfolio/crossword_1.png",
      "/portfolio/crossword_2.png",
      "/portfolio/crossword_3.png",
    ],
    description:
      "Web app generating crosswords based on news categories. Designed for local newspapers to plug in stories and increase reader engagement.",
    tools: ["HTML", "CSS", "JavaScript"],
    timeline: "Winter 2023",
    buttons: [{ label: "Github", link: "https://github.com/annaqchang/cs206" }],
  },
  {
    id: "taskTogether",
    title: "Task Together Mobile App",
    images: ["/portfolio/taskTogether.png"],
    description:
      "Social platform for busy students to run errands, schedule hangouts, and collaborate in groups with RSVP and event tagging features.",
    tools: ["React", "Expo", "JavaScript", "Firebase", "Canva"],
    timeline: "Winter 2023",
    buttons: [],
  },
  {
    id: "realTimeShader",
    title: "Real-Time 3D Shader",
    images: ["/portfolio/3DShader.png"],
    description:
      "Implemented lighting and material shading effects using GLSL, OpenGL's shading language and OpenGL client code in C++. Coding implementations address material pattern logic, material BRDFs and lighting computations to compute surface reflectance.",
    tools: ["C++"],
    timeline: "Winter 2023",
    buttons: [
      {
        label: "Demo",
        link: "https://drive.google.com/file/d/1U0X7LmzAh0PV-K-snr__4M73qtZJ2E5V/view?usp=drive_link",
      },
      {
        label: "Report",
        link: "https://drive.google.com/file/d/11RbtUlaFFFx2lxyaI_KxRlCo9wCw2hIe/view?usp=drive_link",
      },
    ],
  },
  {
    id: "cardinal3D",
    title: "Cardinal3D Graphics Software",
    images: ["/portfolio/cardinal_1.png", "/portfolio/cardinal_2.png"],
    description:
      "Extended implementation of Cardinal3D, a 3D graphics software, by adding interactive mesh editing (edge flip, beveling, triangulation, simplification, etc.) and realistic path tracing (ray generation, object intersection, bounding volume hierarchy, shadow rays) functionality.",
    tools: ["C++"],
    timeline: "Winter 2023",
    buttons: [],
  },
  {
    id: "diaDeLosMuertos",
    title: "Dia de los Muertos 3D Rendering",
    images: ["/portfolio/ddlm_1.png", "/portfolio/ddlm_2.png"],
    description:
      "Created a vibrant, ray-traced digital representation of an ofrenda, incorporating personal and traditional elements such as pan de muerto, photos of loved ones, marigolds, and sugar skulls, to celebrate the holiday's spirit and cultural significance. Created majority of elements from scratch and used advanced Blender features such as particle systems, volumetrics, UV wrapping, and HDRIs.",
    tools: ["Blender"],
    timeline: "Fall 2022",
    buttons: [
      {
        label: "Image",
        link: "https://drive.google.com/file/d/1u1-Oek1xOGkwaly2xapOs1NtcFdFM51U/view?usp=sharing",
      },
      {
        label: "Report",
        link: "https://drive.google.com/file/d/1GvxiaVxw8HkIm7NFaoK_EAkWqpIwIDbD/view?usp=drive_link",
      },
    ],
  },
  {
    id: "soRRRt",
    title: "SoRRRt: Environmental Awareness Video Game",
    images: ["/portfolio/sorrrt.png"],
    description:
      "PC game in Unity teaching players to sort trash correctly, promoting environmental awareness through gameplay.",
    tools: ["Unity", "C#, Plastic SCM"],
    timeline: "Spring 2022",
    buttons: [
      { label: "Play", link: "https://wilmer132.itch.io/sorrrt" },
      {
        label: "Design Process",
        link: "https://mechanicsofmagic.com/2022/06/01/project-2-sorrrt/",
      },
    ],
  },
  {
    id: "langVRse",
    title: "LangVRse",
    images: ["/portfolio/langvrse_1.png", "/portfolio/langvrse_2.png"],
    description:
      "VR game immersing users in new languages and cultures, enhancing fluency through interactive, real-world simulations. Won Best Concept and Third Best Overall Project (of 55).",
    tools: ["Unity", "C#", "VR", "HTML", "CSS"],
    timeline: "Winter 2022",
    buttons: [
      {
        label: "Website",
        link: "https://hci.stanford.edu/courses/cs147/2022/wi/projects/TheVirtualLearnscape/LangVRse/",
      },
    ],
  },
  {
    id: "stanfordShell",
    title: "Stanford Shell",
    images: [],
    description:
      "Fully functional Linux shell in C supporting basic commands, pipelines, and program execution within the terminal environment.",
    tools: ["C"],
    timeline: "Spring 2021",
    buttons: [],
  },
  {
    id: "heapAllocator",
    title: "Implicit and Explicit Heap Allocator",
    images: [],
    description:
      "Implemented implicit and explicit heap allocators in C with first-fit algorithm, coalescing, and in-place reallocation optimizations.",
    tools: ["C"],
    timeline: "Winter 2021",
    buttons: [],
  },
  {
    id: "topParticipants",
    title: "Top Participants Program",
    images: ["/portfolio/cs106b.png"],
    description:
      "C++ program returning top participants from input data using structs and a max-heap-based priority queue.",
    tools: ["C++"],
    timeline: "Fall 2020",
    buttons: [
      {
        label: "Report",
        link: "https://drive.google.com/file/d/1iIXY7k3rOc0A8vyDV-RaR8UVMHWRxSM7/view?usp=sharing",
      },
    ],
  },
  {
    id: "bajillionSearch",
    title: "Bajillion Search Engine",
    images: ["/portfolio/bajillion.png"],
    description:
      "Python search engine using lists, dictionaries, and classes as an extension project for CS 106A Programming Methodology.",
    tools: ["Python"],
    timeline: "Spring 2020",
    buttons: [],
  },
  {
    id: "rainbowSand",
    title: "Rainbow Sand",
    images: ["/portfolio/sand.png"],
    description:
      "Interactive Python graphics project allowing users to place rocks and drop sand that changes color based on location and movement.",
    tools: ["Python"],
    timeline: "Spring 2020",
    buttons: [],
  },
];
